import type { ChartConfig } from '../type/dynamicChart';
import { getMetricLabelKey } from './chartDefaults';

/** Title of a new chart: a translation key, translated by the component that creates the chart. */
const NEW_CHART_TITLE_KEY = 'analytics.dashboard.complexCharts.newChart';

// Default chart for comparison mode (with reference aggregation)
export const DEFAULT_CHART: ChartConfig = {
  id: 'example-1',
  type: 'scatter',
  title: NEW_CHART_TITLE_KEY,
  filters: [],
  filterMode: 'ALL',
  xAxis: {
    metric: 'reference',
    label: getMetricLabelKey('reference'),
  },
  yAxis: {
    metric: 'totalMachiningDuration',
    label: getMetricLabelKey('totalMachiningDuration'),
  },
  options: {
    showTrendLine: false,
    colorBy: 'reference',
    showGridLines: true,
  },
  aggregatedBy: 'reference',
  layout: { size: 'md' as const, order: 0 },
};

// Default chart for analytics mode (with tool aggregation)
export const DEFAULT_ANALYTICS_CHART: ChartConfig = {
  id: 'example-1',
  type: 'scatter',
  title: NEW_CHART_TITLE_KEY,
  filters: [],
  filterMode: 'ALL',
  xAxis: {
    metric: 'toolId',
    label: getMetricLabelKey('toolId'),
  },
  yAxis: {
    metric: 'totalMachiningDuration',
    label: getMetricLabelKey('totalMachiningDuration'),
  },
  options: {
    showTrendLine: false,
    colorBy: 'toolId',
    showGridLines: true,
  },
  aggregatedBy: 'tool',
  layout: { size: 'md' as const, order: 0 },
};
